import React, { useEffect, useState } from "react";
import { Nb_HorizontalMenu } from "../../../components/horizontalMenu/horizontalMenu";
import { NB_DocPlaceSignModule_props } from "../type/docplace_sign_module.types";
import NbTreeFile from "../tree/treeFile";
import { Nb_SearchFilters } from "../../../components/searchFilters/searchFilters";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import GridDocPlace from "../grid/grid.js";
import Button from "@mui/material/Button";
import NbRequestSign from "../requestSigner/docplace_requet_sign";
import { useParams } from "react-router-dom";
import {
  DPwrapper,
  DPTitle,
  DPheader,
  DPbody,
  DPfooter,
  DPHeaderFilter,
  DPbodyList,
} from "../style/docplace_sign_module.styles";
import { colors } from "../../../components/theme";
import { Title } from "../../../components/title/style";
import { BaseDataTable } from "../../../components/common/BaseDataTable";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  "& .MuiDialog-paper": {
    width: "762px",
    maxWidth: "762px",
  },
}));

const NbFormsModuleView: React.FC<
  NB_DocPlaceSignModule_props & { nameButton: string; pageActive: number }
> = ({ ...props }) => {
  const [showRequest, setShowRequest] = useState(false);
  const [showViewRequest, setShowViewRequest] = useState(false);
  const [listDocuments, setListDocuments] = useState<any>([]);
  let params = useParams();

  const setRequest = (item: any) => {
    setListDocuments(item);
    setShowViewRequest(true);
  };

  useEffect(() => {
    if (params.id !== "null" && params.id) {
      setListDocuments([
        {
          id: params.id,
          label: "",
        },
      ]);
      setShowViewRequest(true);
    }
  }, []);

  return (
    <>
      {showViewRequest ? (
        <NbRequestSign
          listDocuments={listDocuments}
          setShowViewRequest={setShowViewRequest}
        />
      ) : (
        <>
          <BootstrapDialog
            onClose={() => {
              setShowRequest(false);
            }}
            aria-labelledby="customized-dialog-title"
            open={showRequest}
          >
            <NbTreeFile
              onClickClose={() => setShowRequest(false)}
              onClickRequest={setRequest}
            />
          </BootstrapDialog>
          {/* <DPwrapper> */}
          <Title>{props.title}</Title>
          <div
            style={{
              marginTop: "10px",
              marginInline: 0,
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: "20px",
              }}
            >
              {/* <DPHeaderFilter> */}
              <div
                style={{ display: "flex", alignItems: "center", gap: "16px" }}
              >
                <Nb_HorizontalMenu
                  menus={props.toolbar}
                  onClickMenu={props.onClickMenu}
                  pageActive={props.pageActive}
                />
                <div>
                  <Button
                    onClick={() => {
                      setShowRequest(true);
                    }}
                    sx={{
                      textTransform: "none",
                      paddingBlock: "6px",
                      backgroundColor: colors.blue,
                    }}
                    size="small"
                    color="primary"
                    variant="contained"
                  >
                    {props.nameButton}
                  </Button>
                </div>
                {/* </DPHeaderFilter> */}
              </div>
              <div style={{ float: "right" }}>
                <Nb_SearchFilters
                  hideList={true}
                  hideFilters={true}
                  isHidden={false}
                />
              </div>
            </div>
            <div
              style={{
                padding: "10px",
                backgroundColor: "#fff",
                borderRadius: "8px",
              }}
            >
              {/* <DPbodyList> */}
              {props.pageActive === 0 ? (
                // <BaseDataTable>
                <GridDocPlace
                  data={props.inbox}
                  option={props.onClickSign}
                  option2={props.onClickView}
                />
              ) : (
                <GridDocPlace
                  data={props.sent}
                  option={props.onClickSign}
                  option2={props.onClickView}
                />
              )}
              {/* </DPbodyList> */}
            </div>
          </div>
          {/* </DPwrapper> */}
        </>
      )}
    </>
  );
};

export default NbFormsModuleView;
